import { Component, ViewEncapsulation } from "@angular/core";

@Component({
  selector: 'pl-scout-corner',
  templateUrl: './corner.component.html',
  styleUrls: [ './corner.component.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class ScoutCornerComponent { }
